import { Message } from '@rossum/api-client/shared';
import { DEV_DEBUG_ENABLED } from '../../constants/config';

type Defined = NonNullable<Message['detail']>;

// sending message attributes separately to have better type predicate for detail type
type DetailPredicate = (
  detail: Message['detail'],
  type: Message['type'] | 'blocker'
) => detail is Defined;

export const isMessageExceptionalError: DetailPredicate = (
  detail,
  type
): detail is Defined => !!(detail && detail.isException && type === 'error');

export const isMessageDetailVisible: DetailPredicate = (
  detail,
  type
): detail is Defined =>
  isMessageExceptionalError(detail, type) || !!(detail && DEV_DEBUG_ENABLED);

type RuleDetail = Message['detail'] & {
  hookName: 'rules';
  ruleId: number;
};

type FormulaDetail = Message['detail'] & {
  hookName: 'computed_fields';
  sourceSchemaId?: string;
  hookId: null;
};

export const isRuleMessageDetail = (
  detail: Message['detail']
): detail is RuleDetail =>
  detail?.hookName === 'rules' &&
  'ruleId' in detail &&
  detail?.ruleId !== undefined;

export const isFormulaMessageDetail = (
  detail: Message['detail']
): detail is FormulaDetail =>
  !!detail && detail.hookName === 'computed_fields' && !detail.hookId;
